var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTanks4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 23H3M22 23H21M21 23V21.5C21 21.2239 20.7761 21 20.5 21V21M21 23H3M3 23V21.5C3 21.2239 3.22386 21 3.5 21H4M4 21V6.30902C4 6.11963 4.107 5.9465 4.27639 5.8618L6.5 4.75M4 21H5.5M12 21V11M12 21H5.5M12 21H13.5M12 11L14 9.66667M12 11V7M18 21H20.5M18 21V19M18 21H13.5M6.5 4.75L7.77639 4.1118C7.91716 4.04142 8.08284 4.04142 8.22361 4.1118L9.5 4.75M6.5 4.75V3C6.5 2.72386 6.72386 2.5 7 2.5H8M9.5 4.75L11.7236 5.8618C11.893 5.9465 12 6.11963 12 6.30902V7M9.5 4.75V3C9.5 2.72386 9.27614 2.5 9 2.5H8M14 9.66667L14.7227 9.1849C14.8906 9.07293 15.1094 9.07293 15.2773 9.1849L16 9.66667M14 9.66667V8C14 7.72386 14.2239 7.5 14.5 7.5H15M16 9.66667L17.7774 10.8516C17.9164 10.9443 18 11.1004 18 11.2676V12M16 9.66667V8C16 7.72386 15.7761 7.5 15.5 7.5H15M15 7.5V1.5C15 1.22386 14.7761 1 14.5 1H8.5C8.22386 1 8 1.22386 8 1.5V2.5M20.5 11V13M20.5 21V19M20.5 19H18M20.5 19V17M18 19V17M18 17H20.5M18 17V15M20.5 17V15M20.5 15H18M20.5 15V13M18 15V13M18 13H20.5M18 13V12M12 7H6.5M18 12H14M5.5 21V10M13.5 21V14",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTanks4);
export default __webpack_public_path__ + "static/media/Tanks4.543ba68fcbe69245f8e12d8bcb810747.svg";
export { ForwardRef as ReactComponent };